import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenResponse } from '../dtos/token-response';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private httpClient: HttpClient) {}

  private readonly url = `${environment.apiUrl}/auth`;

  login(email: string, password: string): Observable<TokenResponse> {
    return this.httpClient.post<TokenResponse>(`${this.url}/authenticate`, {
      email,
      password,
    });
  }

  getToken(): Observable<TokenResponse> {
    return this.httpClient.get<TokenResponse>(`${this.url}/token`);
  }

  isAdmin(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.url}/is-admin`);
  }
}
